'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { SWRConfig } from 'swr';
export { unstable_serialize as serializeKey } from 'swr';
export const DataFetchingProvider = ({ swrConfig, data, children, }) => {
    return _jsx(SWRConfig, { value: Object.assign({ fallback: data }, swrConfig), children: children });
};
